import { Stack, Typography } from "@mui/material"

export function TaskReadOnlySection({ title, direction = "column", children }) {
    return (
        <Stack spacing={1}>
            <Typography variant="subtitle2">{title}</Typography>
            <Stack direction={direction} spacing={1} flexWrap="wrap" useFlexGap>
                {children}
            </Stack>
        </Stack>
    )
}
